import React, { useState, useEffect } from 'react';
import { PrivateAxios } from '../../request/axios';
import { toast } from 'react-toastify';
import Loading from '../loading/Loading';
import Layout from '../layout/Layout';
import InfoMessage from './InfoMessage';
import ModifierMdpUser from './ModifierMdpUser';

const InformationUtilisateur = () => {
    const [userData, setUserData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await PrivateAxios.get('/user');
                setUserData(response.data.user);
            } catch (error) {
                toast.error('Erreur lors de la récupération des informations utilisateur.');
            } finally {
                setIsLoading(false);
            }
        };

        fetchUserData();
    }, []);


    if (isLoading) {
        return <Layout><Loading /></Layout>;
    }

    if (!userData) {
        return <Layout><p className="text-center text-gray-700">Aucune donnée utilisateur disponible.</p></Layout>;
    }

    return (
        <Layout>
            <div className="max-w-4xl p-6 mx-auto space-y-8 bg-gray-100 rounded-lg shadow-lg">
                <h1 className="mb-8 text-3xl font-bold text-center text-blue-800">Paramètres Utilisateur</h1>
                <InfoMessage />

                {/* Carte Informations de base */}
                <div className="p-6 bg-white rounded-lg shadow">
                    <h2 className="mb-4 text-2xl font-semibold text-blue-600">Informations utilisateur</h2>
                    <div className="grid grid-cols-2 gap-4">
                        <div><strong>ID :</strong> {userData.id}</div>
                        <div><strong>Nom d'utilisateur :</strong> {userData.username}</div>
                        <div><strong>Email :</strong> {userData.email}</div>
                        <div><strong>Intermédiaire :</strong> {userData.intermediaire_nom || 'Non attribué'}</div>
                    </div>
                </div>

                {/* Carte Activité & Dates */}
                <div className="p-6 bg-white rounded-lg shadow">
                    <h2 className="mb-4 text-2xl font-semibold text-green-600">Activité & dates</h2>
                    <div className="grid grid-cols-2 gap-4">
                        <div><strong>Date de création :</strong> {new Date(userData.date_creation).toLocaleDateString()}</div>
                        <div><strong>Utilisateur actif :</strong> {userData.actif ? 'Oui' : 'Non'}</div>
                        {userData.date_changement_mdp && (<div><strong>Date de changement du mot de passe : </strong>{new Date(userData.date_changement_mdp).toLocaleDateString()}</div>)}
                    </div>
                </div>

                {/* Carte Rôles */}
                <div className="p-6 bg-white rounded-lg shadow">
                    <h2 className="mb-4 text-2xl font-semibold text-purple-600">Rôles attribués</h2>
                    {Object.keys(userData.roles).length > 0 ? (
                        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                            {Object.values(userData.roles).map(role => (
                                <div key={role.nom} className="p-4 rounded-lg shadow-md bg-gray-50">
                                    <strong className="text-black">{role.nom} :</strong>
                                    <p className="text-gray-700">{role.description}</p>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-gray-600">Aucun rôle attribué.</p>
                    )}
                </div>

                {/* Carte Server */}
                <div className="p-6 bg-white rounded-lg shadow">
                    <h2 className="mb-4 text-2xl font-semibold text-red-600">Version application : 1.1</h2>
                    <h2 className="mb-4 text-2xl font-semibold text-red-600">Mise à jour le 11/12/2025</h2>
                </div>


                {/* Bouton Changer le mot de passe */}
                <div className="p-4 text-center">
                    <ModifierMdpUser />
                </div>
            </div>
        </Layout>
    );
};

export default InformationUtilisateur;
